// extracted by mini-css-extract-plugin
export var columnList = "_bv-0";